export default function IconShare() {
  return (
    <svg
      width="32"
      height="34"
      viewBox="0 0 32 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.7775 5.1739C31.7775 8.03136 29.461 10.3478 26.6036 10.3478C24.9133 10.3478 23.4124 9.53729 22.4682 8.28373L9.79483 14.6703C10.1485 15.3705 10.3478 16.162 10.3478 17.0001C10.3478 17.3946 10.3036 17.7788 10.22 18.148L22.3308 25.9075C23.2627 24.5457 24.8288 23.6521 26.6036 23.6521C29.461 23.6521 31.7775 25.9685 31.7775 28.826C31.7775 31.6835 29.461 33.9999 26.6036 33.9999C23.7686 33.9999 21.4662 31.7198 21.4301 28.8934L8.73119 20.7571C7.80396 21.6353 6.55183 22.174 5.1739 22.174C2.31643 22.174 0 19.8575 0 17.0001C0 14.1426 2.31643 11.8262 5.1739 11.8262C6.0459 11.8262 6.86751 12.0419 7.58829 12.4229L21.4366 5.44419C21.432 5.35467 21.4297 5.26456 21.4297 5.1739C21.4297 2.31643 23.7461 0 26.6036 0C29.461 0 31.7775 2.31643 31.7775 5.1739Z"
        fill="#2D4040"
      />
    </svg>
  )
}
